import company_logo from "../../../../../../src/images/company_logo.jpg"
const Letterhead2 = () => (
  <div className="text-center mb-1 mt-[-20px] mx-auto text-[15px]">
    <img src={company_logo} height={60} width={60} className="mx-auto"/> 
    <div className="w-5 h-5 rounded-full border-2 border-black-500 flex items-center justify-center mx-auto relative top-[-50px] left-[40px]">
  R
</div>
    <h2 className="font-bold text-lg uppercase text-blue-700" style={{fontFamily: "Times New Roman"}}>
      Optim Health and Wellness (OPC) Private Limited
    </h2>
    
    <p className="text-sm" style={{fontFamily: "Times New Roman"}}>H NO 1, Karbi Namghar Path, Khagen Mahanta Road, Hengrabari, Borbari</p>
    <div className="flex justify-center text-sm mt-1 flex-row" style={{fontFamily: "Times New Roman"}}>
    <p>Guwahati – 781036, Assam</p>
    
        <p className="ml-[15px]" style={{fontFamily: "Times New Roman"}}>Email: <a href="mailto:nhwm.oh@gmail.com" className="text-blue-600 underline">nhwm.oh@gmail.com</a></p>
        <p className="ml-[15px]" style={{fontFamily: "Times New Roman"}}>Website: <a href="http://www.nhwm.in" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">www.nhwm.in</a></p>
      </div>
  </div>
);

export default Letterhead2;
